<template>
    <div class="card border-0 bg-dark text-white mb-3 overflow-hidden">
        <!-- begin card-body -->
        <div class="card-body">
            <!-- begin row -->
            <div class="row">
                <!-- begin col-7 -->
                <div class="col-xl-7 col-lg-8">
                    <!-- begin title -->
                    <div class="mb-3 text-grey">
                        <b>TOTAL SALES</b>
                        <span class="ml-2">
                            <i class="fa fa-info-circle" id="total-sales" ></i>
                            <b-popover
                            target="total-sales"
                            title="Total Sales"
                            triggers="hover focus"
                            placement="top"
                            content="Net sales (gross sales minus discounts and returns) plus taxes and shipping. Includes orders from all sales channels."
                            ></b-popover>
                        </span>
                    </div>
                    <!-- end title -->
                    <!-- begin total-sales -->
                    <div class="d-flex mb-1">
                        <h2 class="mb-0"><span data-animation="number" data-value="6450">0.00</span></h2>
                        
                        <!-- 
                    
                            Insert Chart Here (Marvin)

                        -->
                        <div ref="salesLineChart" class="ml-auto mt-n1 mb-n1" style="height : 50px"></div>

                        <!-- <div class="ml-auto mt-n1 mb-n1"><div id="total-sales-sparkline"></div></div> -->
                    </div>
                    <!-- end total-sales -->
                    <!-- begin percentage -->
                    <div class="mb-3 text-grey">
                        <i class="fa fa-caret-up"></i> <span data-animation="number" data-value="33.21">0.00</span>% compare to last week
                    </div>
                    <!-- end percentage -->
                    <hr class="bg-white-transparent-2" />
                    <!-- begin row -->
                    <div class="row text-truncate">
                        <!-- begin col-6 -->
                        <div class="col-4">
                            <div class="f-s-12 text-grey">AVG Daily Sales</div>
                            <div class="f-s-18 m-b-5 f-w-600 p-b-1" data-animation="number" data-value="156">0</div> Unit
                        </div>
                        <!-- end col-6 -->
                        <!-- begin col-6 -->
                        <div class="col-4">
                            <div class="f-s-12 text-grey">Min Daily Sales</div>
                            <div class="f-s-18 m-b-5 f-w-600 p-b-1" data-animation="number" data-value="80">0</div> Unit
                        </div>
                        <!-- end col-6 -->
                        <!-- begin col-6 -->
                        <div class="col-4">
                            <div class="f-s-12 text-grey">Max Daily Sales</div>
                            <div class="f-s-18 m-b-5 f-w-600 p-b-1" data-animation="number" data-value="203">0</div> Unit
                        </div>
                        <!-- end col-6 -->
                        <br><br><br><br><br><br>
                    </div>
                    <!-- end row -->
                    
                </div>
                <!-- end col-7 -->
                <!-- begin col-5 -->
                <div class="col-xl-5 col-lg-4 align-items-center d-flex justify-content-center">
                    <img src="@/assets/img/svg/img-1.svg" height="150px" class="d-none d-lg-block" />
                </div>
                <!-- end col-5 -->
            </div>
            <!-- end row -->
        </div>
        <!-- end card-body -->
    </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
    data(){
        return{
            chart : null
        }     
    },
    mounted(){
        this.renderChart();
    },
    methods : {
        renderChart(){
            this.chart = am4core.create(this.$refs.salesLineChart, am4charts.XYChart);

            this.chart.cursor = new am4charts.XYCursor();
            this.chart.cursor.lineX.disabled = true;
            this.chart.cursor.lineY.disabled = true;

            this.chart.data = [{
                "date": "2012-01-01",
                "value": 8
            }, {
                "date": "2012-01-02",
                "value": 10
            }, {
                "date": "2012-01-03",
                "value": 12
            }, {
                "date": "2012-01-04",
                "value": 14
            }, {
                "date": "2012-01-05",
                "value": 11
            }, {
                "date": "2012-01-06",
                "value": 6
            }, {
                "date": "2012-01-07",
                "value": 50
            }, {
                "date": "2012-01-08",
                "value": 100
            }, {
                "date": "2012-01-09",
                "value": 13
            }, {
                "date": "2012-01-10",
                "value": 15
            }, {
                "date": "2012-01-11",
                "value": 19
            }, {
                "date": "2012-01-12",
                "value": 21
            }, {
                "date": "2012-01-13",
                "value": 22
            }, {
                "date": "2012-01-14",
                "value": 20
            }, {
                "date": "2012-01-15",
                "value": 95
            }, {
                "date": "2012-01-16",
                "value": 100
            }, {
                "date": "2012-01-17",
                "value": 16,
                "opacity": 0
            }, {
                "date": "2012-01-18",
                "value": 18
            }, {
                "date": "2012-01-19",
                "value": 17
            }, {
                "date": "2012-01-20",
                "value": 15
            }, {
                "date": "2012-01-21",
                "value": 12
            }, {
                "date": "2012-01-22",
                "value": 10
            }, {
                "date": "2012-01-23",
                "value": 8
            }];

            let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.dataFields.category = "Date";
            dateAxis.renderer.grid.template.location = 0.5;
            dateAxis.dateFormatter.inputDateFormat = "yyyy-MM-dd";
            dateAxis.renderer.minGridDistance = 40;
            dateAxis.tooltipDateFormat = "MMM dd, yyyy";
            dateAxis.dateFormats.setKey("day", "dd");

            let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());

            dateAxis.renderer.grid.template.disabled = true;
            dateAxis.renderer.labels.template.disabled = true;
            valueAxis.renderer.grid.template.disabled = true;
            valueAxis.renderer.labels.template.disabled = true

            var lineSeries = this.chart.series.push(new am4charts.LineSeries());
            lineSeries.dataFields.valueY = "value";
            lineSeries.dataFields.dateX = "date";
            lineSeries.name = "Sales";
            lineSeries.strokeWidth = 3;
        }
    }   
}
</script>